import React from "react";
import UserList from "./UserList";
import MultiPickerSelectedItems from "components/Picker/MultiPickerSelectedItems";

interface Props {
  selectedUsers: server.dto.UserSmall[]
  onChange: (newUsers: server.dto.UserSmall[]) => void
  excludedUsers?: number[]

  canChooseDeactivated?: boolean
  canChooseExternal?: boolean
}

const UserMultiPicker = (props: Props) => {
  return <MultiPickerSelectedItems
    selectedItems={props.selectedUsers}
    onRemove={props.onChange}
    getId={user => user.userId}
    getLabel={user => user.fullName}
  >
    <UserList
      excludedUsers={props.excludedUsers}
      onUserSelected={(item) => props.onChange([...props.selectedUsers, item])}
      canChooseDeactivated={props.canChooseDeactivated}
      canChooseExternal={props.canChooseExternal}
    />
  </MultiPickerSelectedItems>;
};

export default UserMultiPicker;